import IframeActivity from "./IframeActivity";

export default function Clickbait() {
    return (
        <IframeActivity
            src="/activities/clickbait/index.html"
            title="Attention Hijacked"
        />
    );
}